import {MenuItem} from '@material-ui/core';
import {i18n2} from 'features/i18n/i18n';
import {Field} from 'formik';
import {TextField} from 'formik-material-ui';
import React from 'react';

interface EnumProps {
  //Revisar esto
  data: any[];
  type: string;
  label: string;
  field: string;
  disabled: boolean;
  fullWidth: boolean;
  variant: string | null;
  customValidate: any;
}

const EnumDefault = ({
  data,
  type,
  label,
  field,
  fullWidth,
  disabled,
  variant = 'outlined',
  customValidate = undefined,
}: EnumProps) => {
  return (
    <Field
      style={{margin: 'auto'}}
      type={type}
      name={field}
      label={label}
      disabled={disabled}
      select
      fullWidth={fullWidth}
      variant={variant}
      component={TextField}
      validate={customValidate}
    >
      {data.map((value: any) => {
        return (
          <MenuItem key={value.key} value={value.key}>
            {i18n2._(value.value)}
          </MenuItem>
        );
      })}
    </Field>
  );
};

export default EnumDefault;
